import React from 'react'

const Divider = ({ block }) => {
  const { dividing_space } = block
  const { unit } = dividing_space

  return (
    <div className="block__divider">
      <div
        className="dividing-space dividing-space--mobile"
        style={{ height: `${dividing_space.mobile}${unit}` }}
      />
      <div
        className="dividing-space dividing-space--desktop"
        style={{ height: `${dividing_space.desktop}${unit}` }}
      />
    </div>
  )
}

export default Divider
